"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const makeIcon_1 = require("./makeIcon");
const Check = props => ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "16px", height: "16px", viewBox: "0 0 16 16" }, props, { children: (0, jsx_runtime_1.jsx)("polygon", { points: "14.7713199 2 4.95884603 11.5966813 1.22868046 7.94854812 0 9.15020749 4.95884603 14 16 3.20165971" }, void 0) }), void 0));
exports.CheckIcon = (0, makeIcon_1.makeIcon)('check')(Check);
//# sourceMappingURL=Check.js.map